import { NgModule } from '@angular/core'
import { ScrollingModule } from '@angular/cdk/scrolling'

import { TableColumnComponent } from './table-column/table-column.component'
import { TextCellComponent } from './cell/text-cell.component'
import { LinkCellComponent } from './cell/link-cell.component'
import { TableHeaderControlComponent } from './table-header-control/table-header-control.component'
import { TableHeaderDefaultControlComponent } from './table-header-default-control/table-header-default-control.component'
import { ConnectControlDirective } from './connect-control.directive'
import { PaginatorDefaultDirective } from './paginator-default.directive'
import { TableSettingsComponent } from './settings/table-settings.component'
import { MultilineTextCellComponent } from './cell/multiline-text-cell.component'
import { TableComponent } from './table.component'
import { TableToolbarComponent } from './toolbar/table-toolbar.component'
import { TableToolbarButtonRowComponent } from './toolbar/table-toolbar-button-row.component'
import { VendorModule } from '@shared/vendor.module'
import { DirectiveModule } from '@shared/directives/directive.module'
import { TableMessageComponent } from './table-message.component'
import { DateRangeComponent } from './date-range.component'
import { WidgetsModule } from '@shared/widgets/widgets.module'
import { FormModule } from '@shared/components/form/form.module'
import { TableAutocompleteSelectComponent } from './table-autocomplete-select/table-autocomplete-select.component'
import { TableCellAutocompleteSelectComponent } from './table-cell-autocomplete-select/table-cell-autocomplete-select.component'
import { PaginatorCustomDirective } from './paginator-custom.directive'
import { DateRangeUpdComponent } from './date-range-upd/date-range-upd.component'
import { TableUpdComponent } from './table-upd/table-upd.component'

const declarations = [
  ConnectControlDirective,
  DateRangeComponent,
  DateRangeUpdComponent,
  LinkCellComponent,
  MultilineTextCellComponent,
  PaginatorDefaultDirective,
  PaginatorCustomDirective,
  TableColumnComponent,
  TableComponent,
  TableHeaderControlComponent,
  TableHeaderDefaultControlComponent,
  TableMessageComponent,
  TableSettingsComponent,
  TableToolbarButtonRowComponent,
  TableToolbarComponent,
  TextCellComponent,
  TableAutocompleteSelectComponent,
  TableCellAutocompleteSelectComponent,
  TableUpdComponent,
]

@NgModule({
  declarations,
  imports: [DirectiveModule, FormModule, VendorModule, WidgetsModule, ScrollingModule],
  exports: declarations,
})
export class TablesModule {}
